import React,{useEffect, useContext, useState} from "react";
import { useNavigate } from "react-router-dom";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';

export default function TermsAndConditions({isSubmit}) {
	const [termsDate, setTermsDate] = useState("");
	const [description, setDescription] = useState("");
	const [submitTerm, setSubmitTerm] = useState(false);
	const [error, setError] = useState("");
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
  	const { t } = useTranslation();
	
	useEffect(() => {
		fetchTerms();		
  	}, []);
  	
  	function fetchTerms() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web"}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetTerms","/Service/StaticHelper/GetTerms", requestOptions, getTermsSuccess);
		} catch (error) {
		   // setError(error.message);
		}
	}
  
  	function getTermsSuccess(responseData){
	  	var termsResponse;
	  	if (responseData) {
	    	termsResponse = responseData.getTermsResponse;
	     	if (termsResponse && termsResponse.errorCode === "0") {
				 setTermsDate(termsResponse.terms.updatedAtDisplay);
				 setDescription(termsResponse.terms.description);
	      	}
	 	 }
	}
	
	function handleSubmit(event){
		 event.preventDefault();
		 setSubmitTerm(true);
		 updateTermsDate();
	}
	
	function updateTermsDate(){
		var serverParams = {
	      	userId: userCtx.loggedInUserId,
	      	source: "web",
	    };
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify(serverParams),
	    };
	  try{
        	FetchUtil.fetchAPI("SubmitTerms","/Service/UserService/SubmitTerms", requestOptions, submitTermsSuccess, submitTermsFail);
     	} catch (error) {
        	setError(error.message);
        	setSubmitTerm(false);
     	}
	}
	function submitTermsFail(redirect){
		setSubmitTerm(false);
	  	setError(t("error.termsUpdateFailed"));
  	}
  	function submitTermsSuccess(responseData){
		 setSubmitTerm(false);
	  	 let submitTermsResponse;
	     if (responseData) {
	        submitTermsResponse = responseData.submitTermsResponse;
	       if (submitTermsResponse) {
	            if (submitTermsResponse.errorCode === "0" || submitTermsResponse.errorCode === "23") {
		          navigate("/home_signin");
	            } else {
	               setError(t("error.error") + " " +
	                  submitTermsResponse.errorMessage
	              );
	            }
	        }
	     }   
  	}
  	return (
	<div id="page">
		<div id="main">
			{error && (
	            <div id="inerrorMessage" className="errorblock">
	              {error}
	            </div>
	          )}
			<div className="page-inner">
	            <div className="alert alert-info danger">
				Terms updated&nbsp;
				<span style={{textDecoration: "underline"}} >{termsDate}</span>
				</div>
				<div className="terms-and-conditions-content" style={{padding: "20px", marginBottom: "20px"}} >
					 <div dangerouslySetInnerHTML={{ __html: description }} />
				</div>
				{isSubmit ?  
				<form id="terms" onSubmit={handleSubmit}>
				<div id="submit-spinner" 
					className={submitTerm ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"} 
				>  </div>
				<input type="submit" value="Accept Terms" className="btn" disabled={submitTerm} />
				</form> : 
				null}
			</div>
		</div>
	</div>
	);
}
